<ul class="checklist">
  {{#each checklist_items}}
    <li class="checklist-item {{key}} {{#if custom}}custom{{/if}}" {{#if tab_order}}tabindex="0"{{else}}tabindex="-1"{{/if}} {{#if checked}}data-checked{{/if}}>
      {{#if custom}}
        <button class="{{../delete_custom_button_class}}" data-action="delete" data-checklist="{{key}}" aria-labelledby="{{key}}_label">{{t ../delete_text}}</button>
        <label class="tip" id="{{key}}_label">{{t action_tip}}</label>
      {{else}}
        <input type="checkbox" id="{{key}}_checkbox" class="{{../checkbox_class}}" data-checklist="{{key}}" tabindex="0" {{#if checked}}checked="checked"{{/if}} {{#if auto_add}}disabled="disabled"{{/if}}/>
        <label class="tip" for="{{key}}_checkbox">{{t action_tip}}</label>
      {{/if}}
      <p class="description">
        {{t text}}
        {{#if link}}<a href="{{link.url}}" target="_blank" rel="noopener noreferrer">{{#if link.text}}{{t link.text}}{{else}}{{link.url}}{{/if}}</a>{{/if}}
      </p>
    </li>
  {{/each}}
  {{#if other_field }}
    <li class="checklist-item other-field">
      <input id="other-field-checkbox" type="checkbox" {{#if other_item.text}}checked="checked"{{/if}} />
      <label for="other-field-textbox">{{t other_field.text}}</label>
      <input id="other-field-textbox" type="text" {{#if other_item}}value="{{other_item.text}}"{{/if}} />
    </li>
  {{/if}}
  {{#if empty_text}}
    {{#if list_empty}}
      <li class="checklist-item" {{#if tab_order}}tabindex="0"{{else}}tabindex="-1"{{/if}}>
        <p class="description">{{t empty_text}}</p>
      </li>
    {{/if}}
  {{/if}}
</ul>
{{#if add_custom}}
  <div class="add-custom-checklist">
    <label for="custom-checklist">{{t add_custom_header}}</label>
    <div class="custom-description">{{t add_custom_desc}}</div>
    <textarea id="custom-checklist" aria-required="true" aria-multiline="true"></textarea>
    <div class="error" style="display: none;">{{t add_custom_error}}</div>
    <a href="#" class="{{add_custom_button_class}}" data-checklist="add-custom">{{t add_text}}</a>
  </div>
{{/if}}
